import { createServerFn } from "@tanstack/react-start";

/**
 * حالة برنامج السفراء للواجهة العامّة (قراءة فقط، بلا بيانات خاصّة).
 * تفشل مقفولة: أيّ خطأ = متوقّف، فلا يظهر البرنامج للعميل.
 */
export const getAmbassadorProgramStatus = createServerFn({ method: "GET" }).handler(
  async (): Promise<{ enabled: boolean }> => {
    const { ambassadorProgramActive } = await import("@/lib/server/ambassadorProgramFlag");
    return { enabled: await ambassadorProgramActive("getAmbassadorProgramStatus") };
  },
);
